interface PhoneCallIconProps {
  phoneColor?: string;
  backgroundColor?: string;
  width?: string;
  height?: string;
}

const PhoneCallIcon = (props: PhoneCallIconProps) => {
  const {
    phoneColor = "white",
    backgroundColor = "#002035",
    width = "13.6111",
    height = "13.6111",
  } = props;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="0.194444"
        y="0.194444"
        width={width}
        height={height}
        rx="6.80556"
        fill={backgroundColor}
      />
      <rect
        x="0.194444"
        y="0.194444"
        width={width}
        height={height}
        rx="6.80556"
        stroke="white"
        strokeWidth="0.388889"
      />
      <g clipPath="url(#clip0_947_7555)">
        <path
          d="M9.76892 8.1684C9.34373 8.1684 8.93237 8.09926 8.54867 7.97482C8.42768 7.93333 8.29287 7.96445 8.19953 8.05778L7.65682 8.73877C6.67855 8.2721 5.7625 7.39062 5.27509 6.37778L5.94916 5.80395C6.0425 5.70716 6.07015 5.57235 6.03213 5.45136C5.90422 5.06765 5.83855 4.6563 5.83855 4.23111C5.83855 4.04444 5.68299 3.88889 5.49632 3.88889H4.30027C4.11361 3.88889 3.88892 3.97185 3.88892 4.23111C3.88892 7.44247 6.56101 10.1111 9.76892 10.1111C10.0143 10.1111 10.1111 9.89333 10.1111 9.70321V8.51062C10.1111 8.32395 9.95558 8.1684 9.76892 8.1684Z"
          fill={phoneColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_947_7555">
          <rect
            width="6.22222"
            height="6.22222"
            fill="white"
            transform="translate(3.88892 3.88889)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PhoneCallIcon;
